import React from "react";
import { clsx } from "clsx";
import styles from "./sizeBlock.module.scss";
import { Minus, Plus } from "../SVGasComponent";

type ChangeFunctionInterface = {
    value: number;
    name?: string;
};

type SizeBlockProps = {
    icon?: React.ReactElement;
    label?: string;
    value: number;
    step?: number;
    min?: number;
    max?: number;
    name?: string;
    changeFunction(value: ChangeFunctionInterface): void;
};

export const SizeBlock: React.FC<SizeBlockProps> = React.memo(
    ({ icon, label, value, step = 5, changeFunction, min = 0, max = +Infinity, name }) => {
        const changeInput = (newValue: string) => {
            let valueNumber = +newValue.replace(/[^+-][^0-9]/g, "");

            if (valueNumber > max) {
                valueNumber = max;
            }
            if (valueNumber < min) {
                valueNumber = min;
            }
            if (valueNumber !== value) {
                changeFunction({ name, value: valueNumber });
            }
        };

        const takeStep = (character: "+" | "-") => {
            if (character === "+") {
                changeInput(`${value + step}`);
            } else {
                changeInput(`${value - step}`);
            }
        };

        return (
            <div className={styles.main}>
                {icon}
                <div className={styles.labelText}> {label}</div>
                <div className={styles.sizeBlock}>
                    <button
                        disabled={value === min}
                        className={clsx(
                            styles.inputButton,
                            styles.inputButton_left,
                            value === min && styles.inputButton_disable
                        )}
                        onClick={(e) => {
                            e.stopPropagation();
                            takeStep("-");
                        }}
                    >
                        <Minus size={10} />
                    </button>
                    <input
                        type="text"
                        className={styles.input}
                        name={name}
                        value={value}
                        onChange={(e) => changeInput(e.target.value)}
                    ></input>
                    <button
                        disabled={value === max}
                        className={clsx(
                            styles.inputButton,
                            styles.inputButton_right,
                            value === max && styles.inputButton_disable
                        )}
                        onClick={(e) => {
                            e.stopPropagation();
                            takeStep("+");
                        }}
                    >
                        <Plus size={10} />
                    </button>
                </div>
            </div>
        );
    }
);
